import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { VscAdd } from 'react-icons/vsc'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import {
  allAdmin,
  createAdmin,
} from '../../../../commons/redux/actions/user.actions'
import ItemAdmin from './itemAdmin'
export default function MyAdmin() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const adminReducer = useSelector((state) => state.adminReducer)
  const toast = useToast()
  const dispatch = useDispatch()
  const [load, setLoad] = useState()

  const [data, setData] = useState()
  const token = localStorage.getItem('token')
  const handle = (e) => {
    const { value, name } = e.target
    setData({ ...data, [name]: value })
    console.log(data)
  }
  const createAD = async () => {
    setLoad(true)
    try {
      const res = await dispatch(createAdmin(token, data))
      if (res.status === 400) {
        toast({
          title: 'Champs manquant',
          description: 'Veuillez remplir tous les champs',
          status: 'error',
          duration: 9000,
          isClosable: true,
        })
      }
      if (res.status === 409) {
        toast({
          title: 'Conflit',
          description: 'Cet admin existe deja !',
          status: 'info',
          duration: 9000,
          isClosable: true,
        })
      }
      if (res.status === 200) {
        toast({
          title: 'Admin cree !',
          description: 'Felicitation ,vous avez ajoute un nouvel admin',
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      }
      setLoad(false)
    } catch (error) {
      setLoad(false)

      console.log(error)
    }
  }
  useEffect(() => {
    const token = localStorage.getItem('token')
    dispatch(allAdmin(token))
  }, [dispatch])
  return (
    <div>
      <div className="bg-gray-50 py-10">
        <div className=" col-lg-8 mx-auto bg-white">
          {' '}
          <div className="p-3 flex flex-wrap">
            <h2 className="text-2xl font-bold"> Nos Admins</h2>
            <p className="bg-gray-100 rounded-full text-center font-bold h-10 w-10 p-1 text-xl">
              {' '}
              {adminReducer?.item ? adminReducer?.item?.length : 0}
            </p>

            <div className="ml-auto flex-col text-center text-xs font-bold">
              <button
                onClick={onOpen}
                className="py-1 rounded-full border font-bold bg-gray-200 px-1"
              >
                <VscAdd color="gray" size={24} />
              </button>
              <p>Creer un admin</p>
            </div>
          </div>
          <div className="flex flex-wrap p-3">
            {!adminReducer.item ? (
              <div className="mx-auto text-center">
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color="blue.500"
                  size="xl"
                />{' '}
              </div>
            ) : (
              <div>
                {adminReducer?.item?.length === 0 ? (
                  <div>
                    <div className="text-3xl text-red ">
                      <h2>ZERO</h2>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-wrap p-3">
                    {Array.from(adminReducer?.item).map((value, index) => {
                      return <ItemAdmin {...value} />
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader className="text-center text-2xl text-gray">
            <h3 className="opacity-30">Creer un nouvel admin</h3>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form className="w-full max-w-sm" autoComplete={false}>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-namea"
                  >
                    Nom{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                    id="inline-full-name"
                    type="text"
                    onChange={handle}
                    name="name"
                  />
                </div>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Tel{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                    id="inline-full-name"
                    type="text"
                    name="tel"
                    onChange={handle}
                  />
                </div>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-names"
                  >
                    Ville{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                    id="inline-full-name"
                    type="text"
                    name="town"
                    onChange={handle}
                  />
                </div>
              </div>

              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Quartier{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                    id="inline-full-name"
                    type="text"
                    name="district"
                    onChange={handle}
                  />
                </div>
              </div>

              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    email{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                    id="inline-full-name"
                    type="email"
                    name="email"
                    onChange={handle}
                  />
                </div>
              </div>

              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Mot de passe{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="appearance-none form-control border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                    id="inline-full-name"
                    type="password"
                    name="password"
                    onChange={handle}
                  />
                </div>
              </div>
              <div class="md:flex md:items-center">
                <div class="md:w-1/3"></div>
                <div class="md:w-2/3">
                  {load ? (
                    <Button
                      isLoading={'true'}
                      colorScheme={'facebook'}
                      variant={'outline'}
                      loadingText={'Patientez...'}
                      type="button"
                    ></Button>
                  ) : (
                    <Button
                      onClick={createAD}
                      variant={'solid'}
                      colorScheme={'messenger'}
                      className=" btn bg-red-500 text-white hover:bg-red-800 hover:text-white focus:shadow-outline focus:outline-none font-bold py-2 px-4 btn-block w-full rounded"
                      type="button"
                    >
                      Ajouter admin{' '}
                    </Button>
                  )}
                </div>
              </div>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  )
}
